/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '_Layouts/Layout';
import QLoginRedirect from '_Components/Auth/QLoginRedirect';
import GlobalResults from './GlobalResults';

const title = 'Global Results';
const body = <GlobalResults />;

const action = props => {
  return (
    <QLoginRedirect>
      <Layout body={body} title={title} {...props} />
    </QLoginRedirect>
  );
}

export default action;
